import React from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import {
  getAvailableAnswerOptionsListsExist,
  getFormQuestionAttributeUseSavedOptionsList,
} from "reduxSlices/formBuilderSlice"
import * as SelectAttributes from "./SelectAttributes"
import QuestionRequired from "./QuestionRequired"
import QuestionShowDescription from "./QuestionShowDescription"

const SelectInputConfig = ({ sectionIndex, questionIndex }) => {
  const useSavedOptionsList = useSelector(
    getFormQuestionAttributeUseSavedOptionsList({ sectionIndex, questionIndex }),
  )
  const answerOptionsListsExist = useSelector(getAvailableAnswerOptionsListsExist)
  // Hide the toggle when there's nothing to select -- unless the question is already using a saved
  // list (e.g. the org's lists were removed after this question was configured), so it stays visible
  // to toggle back off.
  const showUseSavedOptionsList = answerOptionsListsExist || useSavedOptionsList

  return (
    <>
      <QuestionRequired
        sectionIndex={sectionIndex}
        questionIndex={questionIndex}
      />
      <QuestionShowDescription
        sectionIndex={sectionIndex}
        questionIndex={questionIndex}
      />
      {
        showUseSavedOptionsList && (
          <SelectAttributes.UseSavedOptionsList
            sectionIndex={sectionIndex}
            questionIndex={questionIndex}
          />
        )
      }
      {
        useSavedOptionsList && (
          <SelectAttributes.AnswerOptionsListSelect
            sectionIndex={sectionIndex}
            questionIndex={questionIndex}
          />
        )
      }
      <SelectAttributes.DisplayAs
        sectionIndex={sectionIndex}
        questionIndex={questionIndex}
      />
      <SelectAttributes.ColumnCount
        sectionIndex={sectionIndex}
        questionIndex={questionIndex}
      />
      <SelectAttributes.DefaultAnswer
        sectionIndex={sectionIndex}
        questionIndex={questionIndex}
      />
    </>
  )
}

SelectInputConfig.propTypes = {
  sectionIndex: types.number.isRequired,
  questionIndex: types.number.isRequired,
}

export default SelectInputConfig
